import { GET_COUPON_FAILED,GET_COUPON_REQUESTED, GET_COUPON_SUCCESS, GET_ADDCOUPON_FAILED, GET_ADDCOUPON_REQUESTED, GET_ADDCOUPON_SUCCESS, GET_UPDATECOUPON_FAILED, GET_UPDATECOUPON_REQUESTED, GET_UPDATECOUPON_SUCCESS, GET_DELETECOUPON_FAILED, GET_DELETECOUPON_REQUESTED,GET_DELETECOUPON_SUCCESS } from "resources/actionTypes";

const initialState = {
  userCoupon: [],
  loading: false,
  error: null,
};

const initialStateAdd = {
  userAddCoupon: [],
  loading: false,
  error: null,
}

const initialStateUpdate = {
  userUpdateCoupon: [],
  loading: false,
  error: null,
}

const initialDelete = {
  userDeleteCoupon: [],
  loading: false,
  error: null,
}

export function userCoupon(state =
  initialState, action) {
  switch (action.type) {
    case GET_COUPON_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_COUPON_SUCCESS:
      return {
        ...state,
        loading: false,
        userCoupon: action.userCoupon
      };
    case GET_COUPON_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}


export function userAddCoupon(state = initialStateAdd, action) {
  switch (action.type) {
    case GET_ADDCOUPON_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_ADDCOUPON_SUCCESS:
      return {
        ...state,
        loading: false,
        userAddCoupon: action.userAddCoupon,
      };
    case GET_ADDCOUPON_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export function userUpdateCoupon(state = initialStateUpdate, action) {
  switch (action.type) {
    case GET_UPDATECOUPON_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_UPDATECOUPON_SUCCESS:
      return {
        ...state,
        loading: false,
        userUpdateCoupon: action.userUpdateCoupon,
      };
    case GET_UPDATECOUPON_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export function userDeleteCoupon(state =
  initialDelete, action) {
  switch (action.type) {
    case GET_DELETECOUPON_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_DELETECOUPON_SUCCESS:
      return {
        ...state,
        loading: false,
        userDeleteCoupon: action.userDeleteCoupon
      };
    case GET_DELETECOUPON_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

